module.exports = __webpack_public_path__ + "static/media/60015568_1288906744592063_641143329148370944_o.cacb6d43.png";